import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import { tw } from "@careinfo/tailwind";

const EditProductComponent = loadable(
  () => import("../../components/ServiceInfo/EditServiceInfo")
);

const EditServiceInfo = () => {
  const { id } = useParams();
  const {
    data,
    isLoading: isDataLoading,
    refetch,
  } = useGetHook({
    url: `${APIS.PRODUCT}${id}/`,
    queryKey: ["inventory-info", `inventory-info-${id}`],
    params: {},
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["inventory-info"],
    navigateURL: "/accounting/service",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.PRODUCT}`;
    const formData = {
      ...values,
      is_maintain_stock: false,
      id: id,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        refetch();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      {isDataLoading ? (
        <Spinner />
      ) : (
        <>
          <div className={tw`grid grid-cols-2 `}>
            <h1 className={tw`font-semibold text-xl leading-10`}>
              Edit Service
            </h1>
          </div>
          <EditProductComponent
            handleEdit={handleEdit}
            isLoading={isPostLoading}
            data={data}
          />
        </>
      )}
    </div>
  );
};

export default EditServiceInfo;
